import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material/";
import { strings } from "../../common/i18n";
import { AssetForm } from "../../common/components";
import MatReactTable from "../../common/components/MaterialReactTable";
import useColumnsRows from "./useColumnsRows";
import Loading from "../../common/components/Loading";

/**
 * Assets Table Component
 */

export default () => {
    const {
        columns,
        data,
        error,
        loading,
        dialogOpen,
        onDialogClose,
        clearItem,
        assetItem,
        toolBarComponents,
        rowActions
    } = useColumnsRows();

    return (
        <>
            {loading && <Loading loadingText="loadingAssets" />}
            <MatReactTable
                persistKey="allAssets"
                columns={columns}
                data={data}
                loading={loading}
                rowActions={rowActions}
                toolBarComponents={toolBarComponents}
                noRowsMessage={strings("messages.noAssets")}
            />

            {assetItem && (
                <Dialog onClose={clearItem} open={dialogOpen}>
                    <DialogTitle>{strings("asset")}</DialogTitle>
                    <DialogContent>
                        <AssetForm onSubmit={onDialogClose} />
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
};
